<script>
/*
  BaseValidCoreを各ValidationComponent内でmixin
*/
export default {
  name: 'BaseValidCore',
  props: {
    // type を特定できないためエラーを無視する.
    // eslint-disable-next-line vue/require-prop-types
    value: {
      required: true
    },
    name: {
      type: String,
      required: true
    },
    errorMsg: {
      type: String,
      default: ''
    },
    popoverErrorMsg: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      inputValue: null
    }
  },
  computed: {
    msgPopperClass () {
      return `${!this.popoverErrorMsg || !this.errorMsg ? 'hidden' : ''}`
    }
  },
  watch: {
    value: function (newValue) {
      this.inputValue = newValue
    }
  },
  beforeCreate () {
    this.$attrs['data-vv-value-path'] = 'inputValue'
  },
  created () {
  },
  beforeMount () {
    this.inputValue = this.value
  },
  mounted () {
    /**
     * el-popoverに"tabindex"が設定されていると、
     * 中にあるinput要素でshift+tabキーが動作しないため"tabindex"を削除
     */
    if (this.$el != null) {
      let popover = this.$el.querySelector('.el-popover__reference')
      if (popover != null) {
        popover.removeAttribute('tabindex')
      }
    }
  },
  methods: {
    updateInputValue (newValue) {
      this.$emit('input', newValue, this.name)
      this.inputValue = newValue
    },
    updateCheckedValue (newValue) {
      this.$emit('input', newValue, this.name)
      this.$emit('checked', newValue, this.name)
      this.inputValue = newValue
    }
  }
}
</script>
